import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=5eacf684&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=5eacf684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eacf684",
  null
  
)

export default component.exports